module.exports = __webpack_public_path__ + "media/overlays/09-fd19309a.png";